import { createSelector } from 'reselect';

const selectUser = state => state.user;

export const selectCurrentUser = createSelector([selectUser], (user)=> ({user: user && user.userData ? user.userData : null, token: user && user.token ? user.token : null}));

export const selectUserCoins = createSelector([selectUser], (user) => user && user.userData && user.userData.coins ? user.userData.coins : 0);

export  const  userToken=createSelector([selectCurrentUser],(user)=>(user && user.token ? user.token : null)); 





